<script>
  import ClickOut from '../../../../../../utils/directives/clickout'
  import Reintegrador from './Reintegrador'
  import OperadoraReboque from './OperadoraReboque'

  export default{
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      clicked: function (e) {
        console.log('prevented!')
        e.preventDefault()
      }
    },
    components: {
      Reintegrador,
      OperadoraReboque
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li :class="{ active: open }">
    <a v-click-out="hide" @click="toggle" class="auto">
      <span class="pull-right text-muted">
      <i class="fa fa-fw fa-angle-right text"></i>
      <i class="fa fa-fw fa-angle-down text-active"></i>
      </span>
      <!-- <i class="icon-screen-desktop icon "></i> -->
      <span>Processo</span>
    </a>
    <ul class="nav nav-sub dk">
      <li class="nav-sub-header"><a><span class="text-muted teste">Polícia Civil</span></a></li>
      <!--<li><a><span>Configurações</span></a></li>-->
      <li>
        <router-link :to="{ name: 'policiacivil.processo.financeira' }">
          <span>Financeira</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.localizacao' }">
          <span>Localização</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.origem-contato' }">
          <span>Origem de Contato</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.servicos' }">
          <span>Serviços</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.tipo-devolucao' }">
          <span>Tipos de Devolução</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.perito-vistoriador' }">
          <span>Perito\Vistoriador</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.seguradora' }">
          <span>Seguradora</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.operador-empilhadeira' }">
          <span>Operador de Empilhadeira</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.situacao-apreensao' }">
          <span>Situação de Apreensão</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.tipo-grv' }">
          <span>Tipos de GRV</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.tipo-remocao' }">
          <span>Tipos de Remoção</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.processo.locadora' }">
          <span>Locadora</span>
        </router-link>
      </li>

      <Reintegrador />
      <OperadoraReboque />
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// Processo.vue?2e85fbba